/**
 * Application-wide settings stored in nc_store
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DEFAULT_APP_SETTINGS", {
    enumerable: true,
    get: function() {
        return DEFAULT_APP_SETTINGS;
    }
});
const DEFAULT_APP_SETTINGS = {
    invite_only_signup: false,
    restrict_workspace_creation: false
};
